import { Button, Tooltip } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { IconShieldCheck } from "@tabler/icons-react";
import { useValidateStepRuleSet } from "./validation.service";

interface ValidateButtonProps {
  readonly stepRuleSetId: string;
  readonly validated: boolean;
  readonly disabled?: boolean;
  readonly onJobStart: (jobId: string) => void;
}

function ValidateButton(props: ValidateButtonProps) {
  const [validate, { loading }] = useValidateStepRuleSet();

  async function handleClick(): Promise<void> {
    try {
      const result = await validate({
        variables: { stepRuleSetId: props.stepRuleSetId },
      });
      if (result.error) {
        throw new Error(result.error.message);
      }
      const jobId = result.data?.validateStepRuleSet?.id;
      if (jobId) {
        props.onJobStart(jobId);
        notifications.show({
          title: "Validation started",
          message: "The rule set is being validated.",
          color: "green",
          autoClose: 3000,
        });
      }
    } catch (err) {
      notifications.show({
        title: "Failed to start validation",
        message: err instanceof Error ? err.message : "Unknown error",
        color: "red",
      });
    }
  }

  if (props.disabled) {
    return (
      <Tooltip label="Apply a preset first before running validation">
        <span>
          <Button
            leftSection={<IconShieldCheck size={16} />}
            disabled
            color="yellow"
          >
            Validate
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      leftSection={<IconShieldCheck size={16} />}
      loading={loading}
      onClick={() => void handleClick()}
      color={props.validated ? "blue" : "yellow"}
    >
      {props.validated ? "Re-validate" : "Validate"}
    </Button>
  );
}

export { ValidateButton };
export type { ValidateButtonProps };
